export function initializeGlintsTrackingClient() {
  window.GlintsTracking = {
    syncConfig: {
      syncIntervalInMs: 3000,
      syncMaxEventBatchSize: 30,
    },
  };
}

export function getGlintsTrackingSyncConfig() {
  if (!window.GlintsTracking?.syncConfig) {
    throw new Error('Glints Tracking sync config is not set');
  }
  return window.GlintsTracking.syncConfig;
}
